export default __webpack_public_path__ + "static/media/resize.1fc385d9.svg";